// extracted by mini-css-extract-plugin
module.exports = {"fileIcon":"fileIcon--7syCK"};